import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { FinanceList } from '../components';

export const FinanceListPage = () => {
  return (
    <PageContainer title="Finance">
      <CardContainer>
        <FinanceList />
      </CardContainer>
    </PageContainer>
  );
};
